export const STRINGS = {
  modalTitle: "Location",
  inputLabel: "Adress",
  inputPlaceholder: "Search Places..",
  loadingStr: "Loading...",
  openModalBtn: "Search location",
  markerTitle: "Current location",
};
